import { render, staticRenderFns } from "./musterikarlilikraporu.vue?vue&type=template&id=988ae4ba&"
import script from "./musterikarlilikraporu.vue?vue&type=script&lang=js&"
export * from "./musterikarlilikraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports